import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './design/tokens.css';
import { registrarServiceWorker } from './pwa/registrar';

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('Elemento #root não encontrado em index.html');
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registro do SW só em produção; em modo 'prompt' a atualização espera o usuário decidir.
if (import.meta.env.PROD) {
  registrarServiceWorker();
}
